import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import closeicon from "../../assets/images/close.svg";
import styles from "../../styles/common/bulkupload.module.css";
import FileRead from "./FileRead";
import { postFile } from "../../utils/api";
import { downloadWasteGeneratedTemplateExcel } from "../../utils/wasteGeneratedExcelTemplate";
import { mergeBulkUploadMatchRows } from "./BulkUploadModal";

/**
 * Waste Generated bulk upload: download uses a client-built Excel template with
 * dependent dropdowns (category → type → method → vendor). Upload flow matches BulkUploadModal.
 */
const BulkUploadModal1 = ({
  onCloseBulkUpload,
  excelData,
  errorClose,
  setMatchData,
  setBulkUploadModal,
  isBulkUploadModal,
  fileName,
  url,
  setsnackOpen,
  matchedKey,
  setFormDataBulkUpload,
  setJsonBulkUpload = null,
  fetchData,
  get,
}) => {
  const [errors, setErrors] = useState(null);
  const [file, setFile] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const tryOpenBulkUploadReview = (responseData) => {
    const excelRows = Array.isArray(responseData?.excelData)
      ? responseData.excelData
      : Array.isArray(responseData?.finalData)
        ? responseData.finalData
        : [];
    const matchRows = mergeBulkUploadMatchRows(responseData, matchedKey);
    const shouldOpenReview =
      responseData?.hasUnmatched ||
      matchRows.length > 0 ||
      excelRows.length > 0;

    if (!shouldOpenReview || !setMatchData) return false;

    const formRows = excelRows.length > 0 ? excelRows : matchRows;
    setMatchData(matchRows);
    setJsonBulkUpload && setJsonBulkUpload(formRows);
    setFormDataBulkUpload && setFormDataBulkUpload(formRows);
    setBulkUploadModal(false);
    errorClose && errorClose();
    return true;
  };

  const handleDownload = async () => {
    const isMultiSheet =
      Array.isArray(excelData) &&
      excelData.length > 0 &&
      excelData[0]?.name &&
      excelData[0]?.data;
    const isEmpty = isMultiSheet
      ? excelData[0]?.data?.length === 0
      : excelData?.length === 0;

    if (isEmpty) {
      setsnackOpen({
        open: true,
        message: "Add masters data before uploading.",
        severity: "error",
      });
      return;
    }
    if (typeof get !== "function") {
      setsnackOpen({
        open: true,
        message: "Template download is not configured (missing API client).",
        severity: "error",
      });
      return;
    }
    try {
      await downloadWasteGeneratedTemplateExcel({ get, fileName });
    } catch (e) {
      console.error(e);
      setsnackOpen({
        open: true,
        message:
          e?.message ||
          "Could not build the Excel template. Check your connection and try again.",
        severity: "error",
      });
    }
  };

  const handleFileChange = (newFile) => {
    setFile(newFile);
    if (newFile) {
      setErrors(null);
    }
  };

  const handleSubmit = async () => {
    setIsSubmitted(true);
    if (!file) {
      setErrors("Please select a file");
    } else if (!url) {
      // no-op
    } else {
      await postFile(url, file)
        .then((res) => {
          const responseData = res?.data || {};
          if (tryOpenBulkUploadReview(responseData)) {
            return;
          }
          setsnackOpen({
            open: true,
            message: responseData.message || "Uploaded successfully",
            severity: "success",
          });
          onCloseBulkUpload();
        })
        .catch((err) => {
          console.log("errw", err?.response);
          if (err?.response?.status === 422) {
            const responseData = err?.response?.data || {};
            if (!tryOpenBulkUploadReview(responseData)) {
              setBulkUploadModal(false);
              setsnackOpen({
                open: true,
                message:
                  responseData.message ||
                  responseData.error ||
                  "Bulk upload validation failed.",
                severity: "error",
              });
            }
          } else if (err?.response?.status === 400) {
            setBulkUploadModal(false);
            setsnackOpen({
              open: true,
              message: err.response?.data?.error ?? "Network Error",
              severity: "error",
            });
            console.log("err", err);
          } else if (fetchData) fetchData();
        });
    }
  };

  useEffect(() => {
    if (!isSubmitted) return;
    if (file) {
      setErrors(null);
    } else {
      setErrors("Please select a file");
    }
  }, [file, isSubmitted]);

  return (
    <Modal
      open={isBulkUploadModal}
      onClose={onCloseBulkUpload}
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "stretch",
      }}
    >
      <Box
        sx={{
          width: "40%",
          height: "100vh",
          display: "flex",
        }}
      >
        <div
          style={{
            width: "30px",
            height: "30px",
            backgroundColor: "white",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0.75rem",
            cursor: "pointer",
          }}
          onClick={onCloseBulkUpload}
        >
          <img src={closeicon} alt="close" />
        </div>
        <div className={styles.upload_div}>
          <p className={styles.heading}>Upload Data</p>
          <div className={styles.table_div}>
            <div className={styles.table_sub_div}>
              <p className={styles.sub_heading}>Step 1 : </p>
            </div>
            <div className={styles.table_sub_div_two}>
              <p className={styles.sub_heading}>
                Download the{" "}
                <span style={{ color: "rgba(72, 130, 87, 1)" }}>.excel</span>{" "}
                File
              </p>
              <p className={styles.comment_heading}>
                Kindly download the excel Template to Continue Filling Data
              </p>
            </div>
          </div>
          <button className={styles.download_button} onClick={handleDownload}>
            Click Here To Download
          </button>
          <div className={styles.table_div}>
            <div className={styles.table_sub_div}>
              <p className={styles.sub_heading}>Step 2 : </p>
            </div>
            <div className={styles.table_sub_div_two}>
              <p className={styles.sub_heading}>
                Fill The Sheet Document & Save
              </p>
              <p className={styles.comment_heading}>
                Fill the downloaded excel sheet & save it on local storage
              </p>
            </div>
          </div>
          <div className={styles.table_div}>
            <div className={styles.table_sub_div}>
              <p className={styles.sub_heading}>Step 3 : </p>
            </div>
            <div className={styles.table_sub_div_two}>
              <p className={styles.sub_heading}>
                Upload the Filled{" "}
                <span style={{ color: "rgba(72, 130, 87, 1)" }}>.excel</span>{" "}
                File
              </p>
              <p className={styles.comment_heading}>
                Kindly Upload The Saved Excel file here
              </p>
            </div>
          </div>
          <FileRead name="file" setFile={handleFileChange} errors={errors} />
          <div className={styles.button_container}>
            <button className={styles.submit_button} onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default BulkUploadModal1;
